import format from 'date-fns/format'
import subMonths from 'date-fns/subMonths'

export function getDefaultRange () {
  const lastMonth = subMonths(new Date(), 1)
  const dateFormat = 'yyyy-MM-dd'
  return [
    format(lastMonth, dateFormat),
    format(new Date(), dateFormat),
  ]
}
